'use client';

// src/app/template.tsx
// Next remonte ce wrapper à CHAQUE navigation → on l'utilise pour une transition
// d'entrée de page (fondu + léger glissement). L'animation est en CSS pur
// (.ln-page-transition dans globals.css) avec fill `backwards` : le transform
// n'est pas retenu après l'anim, ce qui préserve le position:sticky des navbars
// et sidebars. Désactivé automatiquement par prefers-reduced-motion (global).

export default function Template({ children }: { children: React.ReactNode }) {
  return <div className="ln-page-transition">{children}</div>;
}
